/// AUDITORIUM SEATS DATA

export const seat_value = 1500;

const row1 = [
  { plaque: false, text: "" },
  { plaque: true, text: "plaque 1", sold: false },
  { plaque: true, text: "plaque 2", sold: false },
];
const row2 = [
  { plaque: true, text: "Christian Ratsch", sold: true },
  {
    plaque: true,
    sold: true,
    text: (
      <span>
        In honor of
        <br />
        Dr. Christine De Mol
      </span>
    ),
  },
];
const row3 = [];
const row4 = [];
const row5 = [];

export const rows = [row1, row2, row3, row4, row5];

//// DONOR BOARD DATA

export const plaque_values = {
  large: "40000",
  medium: "15000",
  "small=up": "7500",
  "small-down": "7500",
  //Level 3: $7500 (chair plaque)
  //Level 2: $15,000 (small wall plaque)
  //Level 1: $40,000 (large wall plaque)
};

export const base_size = 20;
export const half_size = (0.5 * 20 * 12) / Math.SQRT2;
export const quarter_size = half_size / 2;

export const donor_plaques = [
  {
    size: "large",
    x: half_size,
    y: 0,
    sold: true,
    text: (
      <span>
        Mark Green
        <br />
        and
        <br />
        Kathryn Kert Green
      </span>
    ),
  },
  { size: "large", x: 3 * half_size, y: 0, text: "2 large ", sold: false },
  {
    size: "large",
    x: 5 * half_size,
    y: 0,
    text: (
      <span>
        Ronald and
        <br />
        Sharon Stern
      </span>
    ),
    sold: true,
  },
  { size: "large", x: 7 * half_size, y: 0, text: "4 large", sold: false },
  {
    size: "large",
    sold: true,
    x: 9 * half_size,
    y: 0,
    text: (
      <span>
        <i>
          Advanced
          <br />
          Micro Devices, Inc.
        </i>
      </span>
    ),
  },
  { size: "large", x: 11 * half_size, y: 0, text: "6 large", sold: false },

  {
    size: "medium",
    x: 2 * half_size + quarter_size,
    y: 0,
    text: "1 med",
    sold: false,
  },
  {
    size: "medium",
    x: 4 * half_size + quarter_size,
    y: 0,
    text: "2 med",
    sold: false,
  },
  {
    size: "medium",
    x: 6 * half_size + quarter_size,
    y: 0,
    text: "3 med",
    sold: false,
  },
  {
    size: "medium",
    x: 8 * half_size + quarter_size,
    y: 0,
    text: "4 med",
    sold: false,
  },
  {
    size: "medium",
    x: 10 * half_size + quarter_size,
    y: 0,
    text: "5 med",
    sold: false,
  },

  {
    size: "medium",
    x: 2 * half_size + quarter_size,
    y: half_size,
    text: "6 med",
    sold: false,
  },
  {
    size: "medium",
    x: 4 * half_size + quarter_size,
    y: half_size,
    text: "7 med",
    sold: false,
  },
  {
    size: "medium",
    x: 6 * half_size + quarter_size,
    y: half_size,
    text: "8 med",
    sold: false,
  },
  {
    size: "medium",
    x: 8 * half_size + quarter_size,
    y: half_size,
    text: "9 med",
    sold: false,
  },
  {
    size: "medium",
    x: 10 * half_size + quarter_size,
    y: half_size,
    text: "10 med",
    sold: false,
  },

  { size: "large", x: 0, y: 2 * half_size, text: "7 large", sold: false },
  {
    size: "large",
    x: 2 * half_size,
    y: 2 * half_size,
    text: (
      <span>
        Analog
        <br />
        Devices, Inc.
      </span>
    ),
    sold: true,
  },

  {
    size: "large",
    x: 4 * half_size,
    y: 2 * half_size,
    text: (
      <span>
        J.B.Berland
        <br />
        Foundation
      </span>
    ),
    sold: true,
  },
  {
    size: "large",
    x: 6 * half_size,
    y: 2 * half_size,
    text: (
      <span>
        Alfred W.
        <br />
        and
        <br />
        Virginia D. Hales
      </span>
    ),
    sold: true,
  },
  {
    size: "large",
    x: 8 * half_size,
    y: 2 * half_size,
    text: (
      <span>
        National Science
        <br />
        Foundation
      </span>
    ),
    sold: true,
  },
  {
    size: "large",
    x: 10 * half_size,
    y: 2 * half_size,
    text: <span>Tiger Data Intelligence</span>,
    sold: true,
  },

  {
    size: "medium",
    x: 1 * half_size + quarter_size,
    y: 2 * half_size,
    text: <span>Microsoft </span>,
    sold: true,
  },
  {
    size: "medium",
    x: 3 * half_size + quarter_size,
    y: 2 * half_size,
    text: "12 med",
    sold: false,
  },
  {
    size: "medium",
    x: 5 * half_size + quarter_size,
    y: 2 * half_size,
    text: (
      <span>
        David Balaban
        <br />
        and
        <br />
        Huawen Li
      </span>
    ),
    sold: true,
  },
  {
    size: "medium",
    x: 7 * half_size + quarter_size,
    y: 2 * half_size,
    text: (
      <span>
        Tanya Beder
        <br />
        and
        <br />
        Joseph Bretton
      </span>
    ),
    sold: true,
  },
  {
    size: "medium",
    x: 9 * half_size + quarter_size,
    y: 2 * half_size,
    text: <span>Stan Osher</span>,
    sold: true,
  },

  {
    size: "medium",
    x: 1 * half_size + quarter_size,
    y: 3 * half_size,
    text: "16 med",
    sold: false,
  },
  {
    size: "medium",
    x: 3 * half_size + quarter_size,
    y: 3 * half_size,
    text: "17 med",
    sold: false,
  },
  {
    size: "medium",
    x: 5 * half_size + quarter_size,
    y: 3 * half_size,
    text: (
      <span>
        Leland Wilkinson
        <br />
        and
        <br />
        Marilyn Vogel
      </span>
    ),
    sold: true,
  },
  {
    size: "medium",
    x: 7 * half_size + quarter_size,
    y: 3 * half_size,
    text: <span>C. David Levermore</span>,
    sold: true,
  },
  {
    size: "medium",
    x: 9 * half_size + quarter_size,
    y: 3 * half_size,
    text: "20 med",
    sold: false,
  },

  {
    size: "large",
    x: half_size,
    y: 4 * half_size,
    text: "13 large",
    sold: false,
  },
  {
    size: "large",
    x: 3 * half_size,
    y: 4 * half_size,
    text: (
      <span>
        Julian Schwinger
        <br />
        Foundation for
        <br />
        Physics Research
      </span>
    ),
    sold: true,
  },
  {
    size: "large",
    x: 5 * half_size,
    y: 4 * half_size,
    text: "15 large",
    sold: false,
  },
  {
    size: "large",
    x: 7 * half_size,
    y: 4 * half_size,
    text: "16 large",
    sold: false,
  },
  {
    size: "large",
    x: 9 * half_size,
    y: 4 * half_size,
    text: (
      <span>
        Simons
        <br />
        Foundation
      </span>
    ),
    sold: true,
  },
  {
    size: "large",
    x: 11 * half_size,
    y: 4 * half_size,
    text: "18 large",
    sold: false,
  },

  {
    size: "medium",
    x: 2 * half_size + quarter_size,
    y: 4 * half_size,
    text: "21 med",
    sold: false,
  },
  {
    size: "medium",
    x: 4 * half_size + quarter_size,
    y: 4 * half_size,
    text: "22 med",
    sold: false,
  },
  {
    size: "medium",
    x: 6 * half_size + quarter_size,
    y: 4 * half_size,
    text: "23 med",
    sold: false,
  },
  {
    size: "medium",
    x: 8 * half_size + quarter_size,
    y: 4 * half_size,
    text: "24 med",
    sold: false,
  },
  {
    size: "medium",
    x: 10 * half_size + quarter_size,
    y: 4 * half_size,
    text: "25 med",
    sold: false,
  },

  {
    size: "medium",
    x: 2 * half_size + quarter_size,
    y: 5 * half_size,
    text: "26 med",
    sold: false,
  },
  {
    size: "medium",
    x: 4 * half_size + quarter_size,
    y: 5 * half_size,
    text: "27 med",
    sold: false,
  },
  {
    size: "medium",
    x: 6 * half_size + quarter_size,
    y: 5 * half_size,
    text: "28 med",
    sold: false,
  },
  {
    size: "medium",
    x: 8 * half_size + quarter_size,
    y: 5 * half_size,
    text: "29 med",
    sold: false,
  },
  {
    size: "medium",
    x: 10 * half_size + quarter_size,
    y: 5 * half_size,
    text: "30 med",
    sold: false,
  },

  {
    size: "small-up",
    x: 2 * half_size,
    y: half_size + quarter_size,
    text: "1 sml",
    sold: false,
  },
  {
    size: "small-up",
    x: 3 * half_size,
    y: half_size + quarter_size,
    text: "2 sml",
    sold: false,
  },
  {
    size: "small-up",
    x: 4 * half_size,
    y: half_size + quarter_size,
    text: "3 sml",
    sold: false,
  },
  {
    size: "small-up",
    x: 5 * half_size,
    y: half_size + quarter_size,
    text: "4 sml",
    sold: false,
  },
  {
    size: "small-up",
    x: 6 * half_size,
    y: half_size + quarter_size,
    text: "5 sml",
    sold: false,
  },
  {
    size: "small-up",
    x: 7 * half_size,
    y: half_size + quarter_size,
    text: "6 sml",
    sold: false,
  },
  {
    size: "small-up",
    x: 8 * half_size,
    y: half_size + quarter_size,
    text: "7 sml",
    sold: false,
  },
  {
    size: "small-up",
    x: 9 * half_size,
    y: half_size + quarter_size,
    text: "8 sml",
    sold: false,
  },
  {
    size: "small-up",
    x: 10 * half_size,
    y: half_size + quarter_size,
    text: "9 sml",
    sold: false,
  },
  {
    size: "small-up",
    x: 11 * half_size,
    y: half_size + quarter_size,
    text: "10 sml",
    sold: false,
  },

  {
    size: "small-down",
    x: 2 * half_size,
    y: 2 * half_size,
    text: "11 sml",
    sold: false,
  },
  {
    size: "small-down",
    x: 3 * half_size,
    y: 2 * half_size,
    text: (
      <span>
        Carol Meylan and
        <br />
        Russel Caflisch
      </span>
    ),
    sold: true,
  },
  {
    size: "small-down",
    x: 4 * half_size,
    y: 2 * half_size,
    text: "13 sml",
    sold: false,
  },
  {
    size: "small-down",
    x: 5 * half_size,
    y: 2 * half_size,
    text: (
      <span>
        Dr James C. Fraser and
        <br />
        Diana K. Fraser
      </span>
    ),
    sold: true,
  },
  {
    size: "small-down",
    x: 6 * half_size,
    y: 2 * half_size,
    text: "15 sml",
    sold: false,
  },
  {
    size: "small-down",
    x: 7 * half_size,
    y: 2 * half_size,
    text: <span>Maria Peran McGee</span>,
    sold: true,
  },
  {
    size: "small-down",
    x: 8 * half_size,
    y: 2 * half_size,
    text: "17 sml",
    sold: false,
  },
  {
    size: "small-down",
    x: 9 * half_size,
    y: 2 * half_size,
    text: "18 sml",
    sold: false,
  },
  {
    size: "small-down",
    x: 10 * half_size,
    y: 2 * half_size,
    text: "19 sml",
    sold: false,
  },
  {
    size: "small-down",
    x: 11 * half_size,
    y: 2 * half_size,
    text: (
      <span>
        Dolores and John
        <br />
        Garnett
      </span>
    ),
    sold: true,
  },

  {
    size: "small-up",
    x: 1 * half_size,
    y: 3 * half_size + quarter_size,
    text: (
      <span>
        Monica K Chan
        <br />
        and Tony F Chan
      </span>
    ),
    sold: true,
  },
  {
    size: "small-up",
    x: 2 * half_size,
    y: 3 * half_size + quarter_size,
    text: "22 sml",
    sold: false,
  },
  {
    size: "small-up",
    x: 3 * half_size,
    y: 3 * half_size + quarter_size,
    text: (
      <span>
        George and
        <br />
        Helen Oda Abe
      </span>
    ),
    sold: true,
  },
  {
    size: "small-up",
    x: 4 * half_size,
    y: 3 * half_size + quarter_size,
    text: (
      <span>
        Michel Thacher
        <br />
        and Rhonda Rundle
      </span>
    ),
    sold: true,
  },
  {
    size: "small-up",
    x: 5 * half_size,
    y: 3 * half_size + quarter_size,
    text: (
      <span>
        Amgen
        <br />
        Foundation
      </span>
    ),
    sold: true,
  },
  {
    size: "small-up",
    x: 6 * half_size,
    y: 3 * half_size + quarter_size,
    text: (
      <span>
        <small>
          BT2024 Gift
          <br />
          Honoring <br />
        </small>
        Nancy Potok
        <br />
        <small>BT Chair 2020-2024</small>
      </span>
    ),
    sold: true,
  },
  {
    size: "small-up",
    x: 7 * half_size,
    y: 3 * half_size + quarter_size,
    text: (
      <span>
        Scott and
        <br />
        Monique Miller
      </span>
    ),
    sold: true,
  },
  {
    size: "small-up",
    x: 8 * half_size,
    y: 3 * half_size + quarter_size,
    text: "28 sml",
    sold: false,
  },
  {
    size: "small-up",
    x: 9 * half_size,
    y: 3 * half_size + quarter_size,
    text: (
      <span>
        Jody and
        <br />
        John W. Jacobs
      </span>
    ),
    sold: true,
  },
  {
    size: "small-up",
    x: 10 * half_size,
    y: 3 * half_size + quarter_size,
    text: "30 sml",
    sold: false,
  },

  {
    size: "small-down",
    x: 1 * half_size,
    y: 4 * half_size,
    text: "31 sml",
    sold: false,
  },
  {
    size: "small-down",
    x: 2 * half_size,
    y: 4 * half_size,
    text: "32 sml",
    sold: false,
  },
  {
    size: "small-down",
    x: 3 * half_size,
    y: 4 * half_size,
    text: "33 sml",
    sold: false,
  },
  {
    size: "small-down",
    x: 4 * half_size,
    y: 4 * half_size,
    text: "34 sml",
    sold: false,
  },
  {
    size: "small-down",
    x: 5 * half_size,
    y: 4 * half_size,
    text: "35 sml",
    sold: false,
  },
  {
    size: "small-down",
    x: 6 * half_size,
    y: 4 * half_size,
    text: "36 sml",
    sold: false,
  },
  {
    size: "small-down",
    x: 7 * half_size,
    y: 4 * half_size,
    text: "37 sml",
    sold: false,
  },
  {
    size: "small-down",
    x: 8 * half_size,
    y: 4 * half_size,
    text: "38 sml",
    sold: false,
  },
  {
    size: "small-down",
    x: 9 * half_size,
    y: 4 * half_size,
    text: "39 sml",
    sold: false,
  },
  {
    size: "small-down",
    x: 10 * half_size,
    y: 4 * half_size,
    text: "40 sml",
    sold: false,
  },
];
